<template>
    <el-container>
        <el-header class="header">
            <span>{{ $t('pgCommon.STORAGE_POLICY_TIPS') }}</span>
            <div :class="skinType === 'skinOne' ? 'bottomBorder' : 'bottomBorderBlue'">
                <el-row class="tips">
                    <!-- 接口传的iMaxStorageCount和totalStorageNumber单位是个数，显示的时候需要除10000 -->
                    {{ $t('pgCommon.STORAGE_DATA_COUNT') }}{{ totalStorageCount / 10000 }}{{ $t('pgCommon.NUMBER_COUNT') }}，{{ $t('pgCommon.STORAGE_CURRENT_COUNT') }}{{ totalStorageNumber / 10000 }}{{ $t('pgCommon.NUMBER_COUNT') }}
                </el-row>
            </div>
        </el-header>
        <el-main>
            <div>
                <el-form :model="storageListFrom" ref="storageListFrom" label-position="right">
                    <div v-for="(storagePolicy,index) in storageListFrom.storageList" :key="storagePolicy.sId">
                        <el-row>
                            <el-form-item :label="$t(storagePolicy.sCaption)" style="padding-left: 20px" label-width="8%">
                                <el-col :span="6">
                                    <el-form-item :label="$t('pgCommon.STORAGE_RETAIN_DAY')"  class="item" :label-width="formLabelWidth"
                                                  :prop="'storageList.' + index +'.iTimeValue'"
                                                  :rules="[{required: true, message: $t('pgCommon.PLEASE_INPUT_DAY'), trigger:['change','blur']}]">
                                        <td-input-number v-model="storagePolicy.iTimeValue" :min="0" :max="storagePolicy.iMaxStorageDay" :precision="0"></td-input-number>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item :label="$t('pgCommon.STORAGE_RETAIN_NUMBER')"  v-show="storagePolicy.displayFlg" class="item" label-width="35%"
                                                  :prop="'storageList.' + index +'.iMaxStorageCount'"
                                                  :rules="[{required: true, message: $t('pgCommon.PLEASE_INPUT_NUMBER'), trigger:['change','blur']}]">
                                        <td-input-number v-model="storagePolicy.iMaxStorageCount" :min="0" :max="storagePolicy.iMaxStorageNumber === -1 ? totalStorageCount / 10000 : storagePolicy.iMaxStorageNumber / 10000" :precision="0"></td-input-number>
                                    </el-form-item>
                                </el-col>
                            </el-form-item>
                        </el-row>
                    </div>
                </el-form>
            </div>
        </el-main>
        <el-footer>
            <el-row>
                <div class="btnSaveClass">
                    <td-button type="primary" :loading="saveLoading" :permissions="permissionsSave" @click="submit()">{{ $t('common.SAVE') }}</td-button>
                </div>
            </el-row>
        </el-footer>
    </el-container>
</template>

<script>
import api from './assets/api.js';
export default {
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.getAllStoragePolicy(); // 进行页面初始化数据的加载
    },
    activated() {
        this.getAllStoragePolicy();
    },
    watch:{
        'storageListFrom.storageList':{
            handler: function(){
                this.changeTotalStorageNumber()
            },
            deep:true
        }
    },
    computed: {
        skinType() {
            return window.vue.$store.state.skin;
        }
    },
    // 定义数据
    data() {
        return {
            permissionsSave: ['storagePolicy:save'],
            saveLoading: false,
            showStorageCount: true,
            saveFlag: true,
            formLabelWidth: '25%',
            storageListFrom:{
                storageList:[]
            }
            ,
            captionList: [],
            storagePolicy:{
                iMaxStorageNumber: '',
                iMaxStorageCount: '',
                iMaxStorageDay: '',
                iTimeStatus: '',
                iTimeValue: 90,
                iType: '',
                sCaption: "",
                sExtendGroupFlag: "",
                sExtendInfo: "",
                sId: "",
                displayFlg: false
            },
            totalStorageCount: '', //配置总数(万)
            totalStorageNumber: '' //当前已配置总数(万)
        };
    },
    // 方法的实现
    methods: {
        // 获取策略模块信息
        getAllStoragePolicy() {
            let param = {};
            api.getAllStoragePolicy(param, response => {
                if (null === response || null === response.data) {
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('alarm/getStoragePolicy', response.data.statusMessage);
                    return;
                }
                let content = response.data.content;
                if (null === content.storageList || content.storageList.length === 0) {
                    this.$message({ showClose: true, message: this.$t('error.ERROR_NOT_CONFIG_INFO'), type: 'error' });
                    return;
                }
                this.storageListFrom.storageList = content.storageList;
                //求所有配置数量累加，用于显示当前配置总和
                let sum = 0
                this.storageListFrom.storageList.forEach( storagePolicy => {
                    //如果后台没有初始化配置条数，条数为-1，将单独配置的条数累加
                    if(storagePolicy.iMaxStorageCount > 0){
                        sum += storagePolicy.iMaxStorageCount
                    }
                    //时间为空的给90天
                    if(storagePolicy.iTimeValue == null){
                        storagePolicy.iTimeValue = 90
                    }
                    //如果条数为-1，则不显示条数
                    storagePolicy.displayFlg = storagePolicy.iMaxStorageCount !== -1;
                    //保留条数单位是万，inputNumber中的数量需要除10000，最后保存的时候需要乘回来
                    storagePolicy.iMaxStorageCount = storagePolicy.iMaxStorageCount / 10000;
                })
                this.totalStorageNumber = sum;
                this.totalStorageCount = content.totalStorageCount;
            });
        },
        //计数器改变时就重新计算总数
        changeTotalStorageNumber(){
            let sum = 0
            this.storageListFrom.storageList.forEach( storagePolicy => {
                if(storagePolicy.iMaxStorageCount > 0){
                    sum += storagePolicy.iMaxStorageCount
                }
            })
            //计数器中的数字和需要乘10000，因为显示的时候除了10000
            this.totalStorageNumber = parseInt(sum) * 10000;
        },
        // 提交数据
        submit() {
            this.saveLoading = true;
            this.saveFlag = true;
            //拷贝storageList,用于发送请求
            let tempStorageList = []
            this.storageListFrom.storageList.forEach(item=>{
                let storageItem = {}
                storageItem.iMaxStorageNumber = item.iMaxStorageNumber;
                storageItem.iMaxStorageCount = item.iMaxStorageCount;
                storageItem.iMaxStorageDay = item.iMaxStorageDay;
                storageItem.iTimeStatus = item.iTimeStatus;
                storageItem.iTimeValue = item.iTimeValue;
                storageItem.iType = item.iType;
                storageItem.sCaption = item.sCaption;
                storageItem.sExtendGroupFlag = item.sExtendGroupFlag;
                storageItem.sExtendInfo = item.sExtendInfo;
                storageItem.sId = item.sId;
                if(storageItem.iTimeValue == null || storageItem.iMaxStorageCount == null){
                    this.saveFlag = false;
                    this.captionList.push(item.sCaption)
                }
                tempStorageList.push(storageItem)
            })
            if(!this.saveFlag){
                this.$message({ showClose: true, message: this.captionList + this.$t( 'pgCommon.PLEASE_INPUT_CONTENT'), type: 'error' });
                this.captionList = [];
                this.saveLoading = false;
                return;
            }
            //判断所有配置数量的和是否超过可配置总数，将每条配置的数量乘回来
            let sum = 0;
            tempStorageList.forEach(storagePolicy => {
                storagePolicy.iMaxStorageCount = storagePolicy.iMaxStorageCount * 10000;
                sum += storagePolicy.iMaxStorageCount;
            })
            if(sum > this.totalStorageCount){
                this.$message({ showClose: true, message: this.$t('pgCommon.CURRENT_COUNT_OVER_LIMIT'), type: 'error' });
                this.saveLoading = false;
                return;
            }
            api.saveStoragePolicy(JSON.stringify(tempStorageList), response => {
                this.saveLoading = false;
                if (null === response || null === response.data) {
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('alarm/saveStoragePolicy', response.data.statusMessage);
                    return;
                }
                this.$message({ showClose: true, message: this.$t('common.SAVE_SUCCESS'), type: 'success' });
                this.getAllStoragePolicy();
            });
        }
    }
};
</script>
<style>
.btnSaveClass .el-form-item__content {
    margin-left: 2.3% !important;
}
.btnSaveClass {
    padding-left: 14.7%;
}
.header {
    height:auto !important;
    padding-top:20px !important;
    padding-bottom:5px !important;
    font-size: 14px;
}
.bottomBorder{
    height:auto !important;
    padding-bottom:5px !important;
    font-size: 14px;
    border-bottom: 1px solid #ddd;
}
.bottomBorderBlue{
    height:auto !important;
    padding-bottom:5px !important;
    font-size: 14px;
    border-bottom: 1px solid #04375d;
}
.item {
    padding-top: 0 !important;
}
.tips {
    float:right;
    color: #60d24e;
    font-size: 14px
}
</style>
